import type { PropsWithChildren } from 'react'
import SuspenseWrapper from '@c/suspense-wrapper'
import { Button, Result } from 'antd'
import { ErrorBoundary } from 'react-error-boundary'

const ErrorFallback = ({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) => {
  const navigate = useNavigate()
  return (
    <Result
      extra={[
        <Button key="reset" type="primary" onClick={resetErrorBoundary}>
          刷新
        </Button>,
        <Button key="back" onClick={() => navigate(-1)}>
          返回
        </Button>,
      ]}
      status="error"
      subTitle={`${error.name}: ${error.message}`}
      title="似乎发生了一点小问题"
    />
  )
}

const ErrorBoundaryWrapper = (props: PropsWithChildren) => {
  const [err, setErr] = useState(false)
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} resetKeys={[err]} onReset={() => setErr(false)}>
      {err ? null : <SuspenseWrapper>{props.children}</SuspenseWrapper>}
    </ErrorBoundary>
  )
}

export default ErrorBoundaryWrapper
